import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from 'src/app/app.config';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
	constructor(private appConfig: AppConfig) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const token = localStorage.getItem('alfresco-ticket');
		if (req.url.includes(this.appConfig.get('alfrescoApiUrl'))) {
			if (token) {
				const headers = new HttpHeaders({ Authorization: 'Basic ' + window.btoa(token) });
				req = req.clone({ headers });
			} else if (!req.url.includes('tickets')) {
				console.error('TICKET alfresco non presente!');
			}
		} else if (req.url.includes(this.appConfig.get('wsApiUrl'))) {
			if (token) {
				const headers = new HttpHeaders({ Authorization: 'Basic ' + window.btoa(token) });
				req = req.clone({ headers });
			} else {
				console.error('TICKET alfresco non presente!');
			}
		}

		return next.handle(req);
	}
}
